import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../../utils/styleUtils';

import styles from './FormBlock.scss';


function FormBlock({children, cssClass}) {

    return (
        <fieldset className={styleUtils.toClasses(styles.formBlock, cssClass, 'row')}>
            {children}
        </fieldset>
    );
}


FormBlock.propTypes = {
    children: PropTypes.any,
    cssClass: PropTypes.string
};


export default FormBlock;
